import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {translate} from 'views/module';

import ViewEditBio from './view_edit/ViewEditBio';
import Sections from './sections';

import {simplifyQuestions, hydateQestions} from 'utils/user_bio';

const Biography = (props) => {
  const caregiverBioQuestions = props.caregiverBioQuestions;
  const caregiverBackend = props.caregiverBackend;
  const caregiverRn = props.caregiverRn;
  const [bioQuestions, setBioQuestions] = React.useState({});

  // Load the data
  React.useEffect(() => {
    if (!caregiverBioQuestions?.questions) {
      return;
    }

    const bioQuestions = simplifyQuestions(caregiverBioQuestions.questions);

    setBioQuestions(bioQuestions);
  }, [caregiverBioQuestions]);

  const saveBioQuestions = (fields, onSuccess ) => {
    const bioQuestions = hydateQestions(fields);
    caregiverBackend.bioQuestions.updateMultipleQuestions(bioQuestions, onSuccess);
  };

  return (
    <Stack
      spacing={2}
      sx={{
        margin: 1,
      }}
    >
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.Contact.Title')}
        ViewComponent={Sections.ContactView}
        EditComponent={Sections.ContactEdit}
        saveBioQuestions={saveBioQuestions}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.Profile.Title')}
        ViewComponent={Sections.ProfileView}
        EditComponent={Sections.ProfileEdit}
        saveBioQuestions={saveBioQuestions}
        getSignedFileUrl={caregiverBackend.bioQuestions.getSignedFileUrl}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.Languages.Title')}
        ViewComponent={Sections.LanguagesView}
        EditComponent={Sections.LanguagesEdit}
        saveBioQuestions={saveBioQuestions}
        caregiverRn={caregiverRn}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.Certificate.Title')}
        ViewComponent={Sections.CertificateView}
        EditComponent={Sections.CertificateEdit}
        saveBioQuestions={saveBioQuestions}
        getSignedFileUrl={caregiverBackend.bioQuestions.getSignedFileUrl}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.CanadianId.Title')}
        ViewComponent={Sections.CanadianIdView}
        EditComponent={Sections.CanadianIdEdit}
        saveBioQuestions={saveBioQuestions}
        getSignedFileUrl={caregiverBackend.bioQuestions.getSignedFileUrl}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.VulnerableSectorCheck.Title')}
        ViewComponent={Sections.VulnerableSectorCheckView}
        EditComponent={Sections.VulnerableSectorCheckEdit}
        saveBioQuestions={saveBioQuestions}
        getSignedFileUrl={caregiverBackend.bioQuestions.getSignedFileUrl}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.Education.Title')}
        ViewComponent={Sections.EducationView}
        EditComponent={Sections.EducationEdit}
        saveBioQuestions={saveBioQuestions}
        getSignedFileUrl={caregiverBackend.bioQuestions.getSignedFileUrl}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.WorkHistory.Title')}
        ViewComponent={Sections.WorkHistoryView}
        EditComponent={Sections.WorkHistoryEdit}
        saveBioQuestions={saveBioQuestions}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.References.Title')}
        ViewComponent={Sections.ReferencesView}
        EditComponent={Sections.ReferencesEdit}
        saveBioQuestions={saveBioQuestions}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.PrefsAndAvailability.Title')}
        ViewComponent={Sections.PrefsAndAvailabilityView}
        saveBioQuestions={saveBioQuestions}
        editDisabled={true}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.SkillsAndExp.Title')}
        ViewComponent={Sections.SkillsAndExpView}
        saveBioQuestions={saveBioQuestions}
        editDisabled={true}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.Personality.Title')}
        ViewComponent={Sections.PersonalityView}
        saveBioQuestions={saveBioQuestions}
        editDisabled={true}
      />
      <ViewEditBio
        bioQuestions={bioQuestions}
        title={translate('caregiver.CaregiverBiography.Agreement.Title')}
        ViewComponent={Sections.AgreementView}
        saveBioQuestions={saveBioQuestions}
        editDisabled={true}
      />
    </Stack>
  );
};

Biography.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  refresh: PropTypes.number.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};
export default React.memo(Biography);

